var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{fill:#c7483d;}.cls-5{fill:#347fc0;}.cls-6{fill:#c7483e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.36,20q0,9.63,0,19.25c0,.27-.08.35-.66.35H-16.75c-.54,0-.63-.06-.63-.33q0-19.26,0-38.53c0-.26.06-.34.62-.34Q20,.4,56.79.38c.51,0,.59.06.59.32Q57.35,10.35,57.36,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.56,24c-5.25,0-10.49,0-15.73,0-.8,0-.93.24-.93,1,0,4.62,0,9.23,0,13.84,0,.64-.17.81-.81.8q-3.16-.06-6.33,0c-.58,0-.74-.15-.73-.73,0-4.63,0-9.27,0-13.91,0-.72-.13-1-.93-1-10.48,0-21,0-31.45,0-.61,0-.83-.09-.81-.77.05-2.13,0-4.27,0-6.4,0-.64.19-.74.77-.74q15.74,0,31.46,0c.94,0,.94,0,.94-.92,0-4.69,0-9.37,0-14,0-.63.18-.76.77-.75,2.11,0,4.23,0,6.34,0,.59,0,.77.12.77.75,0,4.73,0,9.46,0,14.19,0,.66.19.8.82.8,10.55,0,21.11,0,31.67,0,.63,0,.87.11.85.81-.06,2.11-.05,4.22,0,6.33,0,.68-.2.78-.81.78C51.14,24,45.85,24,40.56,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-10.2.43Q1.38.43,13,.43c.36,0,.51.09.51.48,0,3.79,0,7.57,0,11.5L-10.23.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.23.56,26.68,12.34c-.22-.16-.14-.35-.14-.5q0-5.35,0-10.71c0-.36-.09-.71.51-.71,7.72,0,15.44,0,23.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-9.9,39.55c.1-.23.33-.26.51-.35L12.77,28.11c.51-.26.72-.32.71.4,0,3.47,0,6.94,0,10.4,0,.46-.06.7-.62.7-7.54,0-15.08,0-22.63,0A.34.34,0,0,1-9.9,39.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.05,39.6c-7.73,0-15.29,0-22.86,0-.5,0-.67-.14-.67-.66,0-3.51,0-7,0-10.54,0-.43,0-.65.53-.39q11.3,5.67,22.62,11.32A3.5,3.5,0,0,1,50.05,39.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.51,13.39l1.55-.79L52.91.69a3,3,0,0,1,3.38.48c.42.39.47.58-.13.88C51.4,4.4,46.67,6.78,41.92,9.16L33.8,13.22a2.69,2.69,0,0,1-1.25.31c-1.67,0-3.34,0-5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-16.45,38.31l.64-.34,22-11a3,3,0,0,1,1.38-.34c1.65,0,3.3,0,5,0-.06.29-.32.29-.49.38L-12.55,39.32A3.19,3.19,0,0,1-16.45,38.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.35,26.65c1.82,0,3.63,0,5.45,0a1.48,1.48,0,0,1,.68.22q8.6,4.3,17.2,8.59c.4.2.61.41.55.87a6.93,6.93,0,0,1-.11,1c-.32,1.08-.41,1.13-1.4.64L34,27.1l-.64-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.62,13.52c-1.81,0-3.54,0-5.26,0a2.29,2.29,0,0,1-1-.31Q-8,9-16.32,4.91c-.59-.29-.86-.62-.76-1.26,0-.24,0-.49,0-.73.14-1.11.35-1.21,1.33-.72L5.92,13A1.24,1.24,0,0,1,6.62,13.52Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngland);
export default __webpack_public_path__ + "static/media/england.71cdaf20fd0c60a573debf09189a3b06.svg";
export { ForwardRef as ReactComponent };